import Page from "webPage/Page";

import {handleScrollingSection} from "util/scrolling-section";

Page.register('page-template-additional-details', () => {
    this.$element.find('.js-upload-row').show();

    handleScrollingSection($(".js-rating-track-wrap"), 0, 1199);
});
